import { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../helpers/formatDate";

import { AvailableOffers } from "../../../types/rtk/availableOffers/availableOffers";
import { SubscriptionItem } from "../../../types/rtk/currentSubscriptionsOptions/currentSubscriptionsOptions";

import Title from "../../atoms/Title/Title";
import Text from "../../atoms/Text/Text";
import ChangeSubscriptionCard from "../../molecules/ChangeSubscriptionCard/ChangeSubscriptionCard";

interface Props {
  offers?: AvailableOffers;
  currentSubscription?: SubscriptionItem | null;
  onSelectionChange?: (choicePeriod: number | null) => void;
}

const EditSubscriptionChoice = ({ offers, currentSubscription, onSelectionChange }: Props) => {
  const { t } = useTranslation();
  const [selectedChoice, setSelectedChoice] = useState<number | null>(null);

  const handleSelect = (choiceKey: number | null) => {
    setSelectedChoice(choiceKey);
    onSelectionChange?.(choiceKey);
  };

  return (
    <Box className="EditSubscriptionChoice">
      <Box className="changeSubscriptionChoiceContainer">
        <Title
          variant="h1"
          className="changeSubscriptionChoiceTitle"
          children={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.CHANGE.TITLE")}
        />
        <Text
          className="changeSubscriptionChoiceTextSubtitle"
          children={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.CHANGE.SUBTITLE")}
        />
      </Box>
      {offers && offers.subscriptions
        .filter((data) => data.available === true)
        .sort((a, b) => a.period - b.period)
        .map((data) => (
          <ChangeSubscriptionCard
            key={data.period}
            offers_data={data}
            current_subscription={currentSubscription}
            isActive={selectedChoice === data.period}
            onSelect={() => handleSelect(data.period)}
          />
        ))}
      <Box className="changeSubscriptionChoiceContainer cancelSubscriptionChoiceContainer">
        <Title
          variant="h1"
          className="changeSubscriptionChoiceTitle"
          children={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.CANCEL.TITLE")}
        />
        <Text
          className="changeSubscriptionChoiceTextSubtitle"
          children={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.CANCEL.SUBTITLE", { date: formatDate(currentSubscription!.next_charge_at) })}
        />
      </Box>

      <ChangeSubscriptionCard
        key={"cancel_subscription"}
        offers_data={null}
        current_subscription={currentSubscription}
        isActive={selectedChoice === 0}
        onSelect={() => handleSelect(0)}
      />
    </Box>
  );
};

export default EditSubscriptionChoice;